export default {
    state: {
      'dutyAgmtByModel': [],
    },
    mutations: {
      'SET_DUTY_AGMT_BY_MODEL': (state, arr) => {
        state['dutyAgmtByModel'] = arr
      },
    },
    actions: {
      SetDutyAgmtByModel({ commit }, arr) {
        commit('SET_DUTY_AGMT_BY_MODEL', arr)
      }
    }
  }